<div id="academy-course" class="page-layout simple left-sidebar inner-scroll">

    <!-- CENTER -->
    <div class="center">

        <!-- CONTENT -->
        <div id="course-content" class="content">
            <!-- ------contenido------ -->
            <div class="page-layout carded fullwidth inner-scroll cursoStep">
                <!-- TOP BACKGROUND -->
                <div class="top-bg"></div>
                <!-- CENTER -->
                <div class="center">
                    <!-- CONTENT HEADER -->
                    <div class="header p-24" fxLayout="row" fxLayoutAlign="start center">
                        <h2 class="m-0">{{'WIZARD.CT_INFORMACION.LISTA.TITULO' | translate}}</h2>
                    </div>
                    <!-- CONTENT CARD -->
                    <div class="content-card" [@animate]="{value:'*',params:{delay:'100ms', y:'25px'}}">
                        <!-- CONTENT TOOLBAR -->
                        <div class="toolbar primary px-24 py-8">
                            <span>{{'WIZARD.CT_INFORMACION.LISTA.SUBTI' | translate}}</span>
                        </div>
                        <!-- CONTENT -->
                        <div class="content" fusePerfectScrollbar>
                            <mat-drawer-container class="example-container">
                                <mat-drawer #drawer class="example-sidenav" mode="side" opened="true">
                                    <p>Productos asginados</p>
                                    <ng-container *ngIf="cargaCompleta">
                                        <div fxLayout="column" fxLayoutAlign="space-around start">
                                            <mat-tree [dataSource]="dataSourceTree" [treeControl]="treeControl">
                                                <mat-tree-node class="step pl-10 fade" *matTreeNodeDef="let node; let k = index;" matTreeNodePadding>
                                                    <button mat-icon-button active class="fade Efect-tree" mat-icon-button matTreeNodeToggle [attr.aria-label]="'toggle ' + node.name">
                                                        <mat-icon class=" mat-icon-rtl-mirror" >
                                                            {{treeControl.isExpanded(node.name) ? 'more_horiz' : 'chevron_right'}}
                                                        </mat-icon>
                                                    </button>
                                                    <p style="padding-right:50px;"> {{node.translate | translate}} {{node.anio}} </p>
                                                </mat-tree-node><br>
                                                <mat-tree-node class="step pl-10 fade Efect-tree" *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding>
                                                    <button class=" fade Efect-tree " mat-icon-button matTreeNodeToggle [attr.aria-label]="'toggle ' + node.name">
                                                            <mat-icon class=" mat-icon-rtl-mirror" >
                                                                {{treeControl.isExpanded(node) ? 'arrow_drop_up' : 'arrow_drop_down_circle'}}
                                                            </mat-icon>
                                                        </button>
                                                    <p style="padding-right:80px; text-align: left; ">{{node.translate | translate}} </p>
                                                </mat-tree-node>
                                            </mat-tree>
                                        </div>
                                    </ng-container>

                                </mat-drawer>

                                <div class="example-sidenav-content" style="padding-top: 0px;">
                                    <div fxLayout="row" fxLayoutAlign="start ">
                                        <ng-container *ngIf="numSeccion == 1">
                                            <div class="course-step-content p-20">
                                                <div fxLayout="column" fxLayoutAlign="start stretch">
                                                    <h2>Certificar</h2>
                                                </div>
                                                <div fxLayout="column" fxLayoutAlign="space-around stretch">
                                                    <button type="button" mat-button (click)="drawer.toggle()">
                                                                Toggle sidenav
                                                            </button>
                                                </div>
                                            </div>
                                            <!-- -->
                                        </ng-container>
                                    </div>
                                </div>
                            </mat-drawer-container>
                        </div>

                    </div>
                </div>
            </div>
            <!-- ------contenido------ -->
        </div>
        <!-- / CONTENT -->

    </div>
    <!-- / CENTER -->

</div>